//---------------------------------------------------------------------------------------------------
// ## IMPORTS ##
// Library Imports
// Material ui Imports

import { Grid, Tooltip, Typography } from "@mui/material";
import { EDragContentOptions } from "../../models/hotspotDrag.models";
import { useState } from "react";
import { VTImmersiveImageSegment } from "@virtus-tech-repository/virtus-tech-repository";
import { AddRounded, DeleteRounded } from "@mui/icons-material";

// Custom components imports (and hooks and helpers)
// Media imports

//---------------------------------------------------------------------------------------------------
// ## MUI STYLED ##
// Layout stuff remains inline, other styling pulled into it's own components

//---------------------------------------------------------------------------------------------------
// ## INTERFACES ##
interface IProps {
    item: any;
    organisation: any;
    localHandleDrag: any;
    handleDoubleClick: (mediaType: EDragContentOptions, src: string, preview?: string) => void;
    addFunction?: any;
    deleteFunction?: any;
}

//---------------------------------------------------------------------------------------------------
// ## COMPONENTS ##
// Only display layouts in pages
export default function VTImmersiveImageDraggable({
    item,
    organisation,
    localHandleDrag,
    handleDoubleClick,
    addFunction,
    deleteFunction,
}: IProps) {
    //-------------------------------------------------------------------------------------------------
    // ## HOOKS ##

    //-------------------------------------------------------------------------------------------------
    // ## USE SELECTOR ##

    const [dragging, setDragging] = useState<boolean>(false);
    const [hover, setHover] = useState<boolean>(false);
    //-------------------------------------------------------------------------------------------------
    // ## USE STATE ##

    //-------------------------------------------------------------------------------------------------
    // ## USE EFFECTS ##

    //-------------------------------------------------------------------------------------------------
    // ## CUSTOM FUNCTIONS ##
    // Render for the tab buttons
    function textCutOffAddElipsis(text: string, cutOffPointCharIndex: number) {
        const charAtIndex = text.charAt(cutOffPointCharIndex);
        if (charAtIndex === " ") {
            return text.substring(0, cutOffPointCharIndex) + "...";
        } else if (charAtIndex === "") {
            return text;
        } else {
            return text.substring(0, cutOffPointCharIndex + 1) + "...";
        }
    }

    //-------------------------------------------------------------------------------------------------
    // ## RETURN ##
    // Show creator page tabs options
    return (
        <Grid
            item
            key={item.id}
            xs={12}
            sx={{
                padding: "5px",
                maxHeight: "150px",
                position: "relative",
            }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            {hover && (
                <>
                    <Grid
                        item
                        xs={12}
                        sx={{
                            position: "absolute",
                            top: "20px",
                            left: "5px",
                            right: "7px",
                            borderRadius: "15px 15px 0px 0px",
                            userSelect: "none",
                            height: "35px",
                            backgroundColor: "rgba(22,22,22,0.8)",
                        }}
                    >
                        <Typography
                            sx={{
                                marginLeft: "5px",
                                marginTop: "5px",
                            }}
                        >
                            {item && item.name && item.name?.length > 20
                                ? textCutOffAddElipsis(item.name, 20)
                                : item.name}
                        </Typography>
                    </Grid>{" "}
                    <Grid
                        item
                        xs={12}
                        sx={{
                            position: "absolute",
                            bottom: 5,
                            right: 15,
                            userSelect: "none",
                            height: "35px",
                            zIndex: 10000,
                        }}
                    >
                        {deleteFunction && (
                            <Tooltip title={"Delete from scenario media"}>
                                <DeleteRounded
                                    onClick={deleteFunction}
                                    sx={{
                                        backgroundColor: "rgba(22,22,22,0.8)",
                                        borderRadius: "50%",
                                        cursor: "pointer",
                                    }}
                                />
                            </Tooltip>
                        )}
                        {addFunction && (
                            <Tooltip title={"Add to your media"}>
                                <AddRounded
                                    onClick={addFunction}
                                    sx={{
                                        backgroundColor: "rgba(22,22,22,0.8)",
                                        borderRadius: "50%",
                                        cursor: "pointer",
                                        marginLeft: "10px",
                                    }}
                                />
                            </Tooltip>
                        )}
                    </Grid>
                </>
            )}
            <img
                // TODO: change to media type
                src={`${process.env.REACT_APP_NINJA_MEDIA}/${organisation}/three_sixty_image/${item.id}/f.jpg`}
                alt={item.name}
                loading="lazy"
                style={{
                    borderRadius: "15px",

                    height: "116px",
                    width: "350px",
                    zIndex: 1,
                    position: "absolute",
                    top: "20px",
                    left: "5px",
                    right: "5px",
                    opacity: dragging ? 1 : 0,
                    cursor: "pointer",
                }}
                draggable={true}
                onDragStart={() => {
                    localHandleDrag(
                        true,
                        EDragContentOptions.IMAGE_360,
                        `${process.env.REACT_APP_NINJA_MEDIA}/${organisation}/three_sixty_image/${item.id}`,
                    );
                    setDragging(true);
                }}
                onDragEnd={() => {
                    localHandleDrag(false);
                    setDragging(false);
                }}
                onDoubleClick={() =>
                    handleDoubleClick(
                        EDragContentOptions.IMAGE_360,
                        `${process.env.REACT_APP_NINJA_MEDIA}/${organisation}/three_sixty_image/${item.id}`,
                    )
                }
            />
            <VTImmersiveImageSegment
                size={"Large"}
                immersiveImagesTitle={item.title}
                sx={{ marginTop: "15px" }}
                segmentPath={`${process.env.REACT_APP_NINJA_MEDIA}/${organisation}/three_sixty_image/${item.id}`}
            />
        </Grid>
    );
}
